import { postRequest } from 'utils/api/apiRequest'
import { SocialWallPost } from 'utils/api/SocialWall/types'

export type PostLikePayload = {
  post: number
}
export type PostLikeResponse = Pick<SocialWallPost, 'likes' | 'id'>
export const postLike = (data: PostLikePayload) => postRequest<PostLikeResponse>(`/social-wall/posts/likes`, data)
